export default "__VITE_ASSET__CVjwtYfI__"